export default 
{
	"progressbar-page-title": "Sida",
	"name-suffix": "Suffix",
	"fileupload-desc-progress-message": "Uppladdning {progress}",
	"required-if-greater-than-or-equal": "{property} krävs när {compareSource} är större än eller lika med {compareValue}.",
	"powered-by-cognito": "Drivs av Cognito Forms.",
	"form-name-default": "Untitled",
	"field-choice-defaults": "Första Val|Andra Val|Tredje Val",
	"additional-fee-default-label": "Extra avgift",
	"authenticated-save-and-resume-email-dialog": "Skicka en länk via e-post och återgå till ditt formulär för att slutföra din inlämning.",
	"string-length-between": "{property} måste vara mellan {min} och {max} tecken.",
	"update-button-text": "Uppdatera",
	"address-zip-code-invalid": "Zip Code måste formateras som #####-####.",
	"required-if-greater-than": "{property} krävs när {compareSource} är större än {compareValue}.",
	"compare-before": "{property} måste vara innan {compareSource}.",
	"compare-after": "{property} måste vara efter {compareSource}.",
	"unsupported-browser-message": "Åh nej! Du använder en webbläsare som stöds inte. {a}Klicka här { / a} om du vill uppgradera.",
	"shared-entry-email-subject": "Delad Länk",
	"send-button-text": "Skicka",
	"venmo-help-text": "Anslut till Venmo om du vill fortsätta med beställningen.",
	"field-repeatingsection-item-label": "Objekt",
	"save-and-resume-email-not-sent-message": "Det var ett problem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} måste vara minst {min}.",
	"entry-notification-full-entry-detail-link": "Visa hela posten detaljer på cognitoforms.com.",
	"element-label-website": "Webbplats",
	"element-label-signature": "Namnteckning",
	"paypal-help-text": "Anslut till PayPal om du vill fortsätta med beställningen.",
	"card-on-file-agreement-validation": "Du måste godkänna att spara ditt kort för framtida transaktioner.",
	"marketing-button-4": "Bygg Din Egen Gratis",
	"field-datepicker-now": "Nu",
	"save-and-resume-email-resume-button": "Fortsätt nu",
	"field-datepicker-next-month": "Nästa månad",
	"quantity-remaining-text": "återstående",
	"payment-declined": "Betalning minskade",
	"required-if-before": "{property} krävs när {compareSource} är innan {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} måste vara mindre än {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} krävs.",
	"save-and-resume-multiple-days-expiration-email-message": "Kopiera eller e-posta länken nedan och återgå till formuläret inom de närmaste {days} dagar att slutföra din ansökan.",
	"string-length-at-least": "{property} måste vara minst {min} tecken.",
	"credit-card-number": "Kreditkortsnummer",
	"range-on-or-before": "{property} måste vara på eller före {max}.",
	"required-one": "{0} krävs.",
	"fileupload-max-file-count-exceeded-message": "Endast {maxFileCount} filer kan laddas upp.",
	"order-transaction-details-header": "Transaktionsdetaljer",
	"field-spinner-increase": "Öka",
	"payment-processing-fees": "Bearbetning avgifter",
	"payment": "Betalning",
	"field-choice-other-fill-in": "Övrigt",
	"shared-entry-email-message": "En post har delats med dig.",
	"shared-entry-workflow-link": "Se formuläret.",
	"required-if-exists": "{property} krävs när {compareSource} har angetts.",
	"concurrent-conflict-toast-message": "Inlämningen misslyckades eftersom informationen i formuläret ändrades. Kontrollera och försök igen.",
	"secured-by-paypal": "Säkrad med ",
	"range-on-or-after": "{property} måste vara på eller efter {min}.",
	"payment-amount-due": "Att betala",
	"required-name-first-and-last": "Förnamn och Efternamn krävs.",
	"required": "{property} krävs.",
	"string-format-alphabetic": "{property} får bara innehålla bokstäver.",
	"quantity-limit": "{property} kvantitet överskridits.",
	"field-spinner-decrease": "Minska",
	"field-repeatingsection-add-link-text": "Lägg till",
	"fileupload-max-size-exceeded-message": "Endast filer som är mindre än {maxSize} MB kan laddas upp.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Inte Fångas",
	"field-ratingscale-satisfied-unsatisfied-label": "Nöjd/Missnöjd",
	"range-between": "{property} måste vara mellan {min} och {max}.",
	"field-ratingscale-agree-disagree-label": "Håller/Enas",
	"back-button-text": "Tillbaka",
	"address-country": "Land",
	"order-not-found": "Ingen orderinformation hittas.",
	"field-ratingscale-satisfied-unsatisfied-options": "Mycket missnöjd|Missnöjd|Neutral|Nöjd|Mycket nöjd",
	"entry-notification-entry-details-header": "Detaljer",
	"FALSE": "FALSKT",
	"compare-greater-than-or-equal": "{property} måste vara större än eller lika med {compareSource}.",
	"receipt-notification-order-details-desc-header": "Beskrivning",
	"order-method-label": "Betalningssätt",
	"order-total-label": "Ordersumman",
	"invalid-shared-link": "Ogiltig Delad Länk",
	"fileupload-zero-byte-file-message": "Noll byte filer kanske inte laddas upp.",
	"range-at-most": "{property} måste vara på de flesta {max}.",
	"format-integer": "####",
	"order-date-label": "Datum",
	"fileupload-dropzone-message": "Dra filen hit.",
	"shared-entry-view-link": "Visa den delade posten.",
	"format-currency": "# ###,## kr",
	"string-length-at-most": "{property} måste vara högst {max} tecken.",
	"entry-confirmation-footer-tagline": "Skapa din egen kraftfulla betalningsblanketter med",
	"submit-button-text": "Lämna in",
	"marketing-msg": "Enkelt skapa kraftfulla former.",
	"required-if-on-or-after": "{property} krävs när {compareSource} är på eller efter {compareValue}.",
	"card-on-file-agreement": "Jag godkänner att spara mitt kort för framtida transaktioner.",
	"signature-draw": "rita",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} måste vara på eller efter {compareSource}.",
	"required-if-less-than-or-equal": "{property} krävs när {compareSource} är mindre än eller lika med {compareValue}.",
	"field-datepicker-next-year": "Nästa år",
	"change-button": "förändra",
	"fileupload-desc-size-in-bytes-message": "{size} byte",
	"card-tab": "Kort",
	"order-billing-info-header": "Fakturainfo",
	"entry-email-view-details-text": "Visa hela posten på CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Kopiera eller e-posta länken nedan och återgå till formuläret inom den nästa dag för att slutföra din ansökan.",
	"credit-card-authentication-failed": "Kreditkort misslyckades autentisering.",
	"compare-less-than-or-equal": "{property} måste vara mindre än eller lika med {compareSource}.",
	"receipt-notification-order-details-balance-due": "Balansera vederbörlig",
	"save-and-resume-multiple-days-expiration-message": "Kopiera eller e-posta länken nedan och återgå till formuläret inom de närmaste {days} dagar att slutföra din ansökan.",
	"processing-fee-calculating-message": "Beräkning av",
	"receipt-notification-trx-details-method": "Betalningssätt",
	"field-choice-no-match": "Hittade inget",
	"fileupload-invalid-file-type-message": "Endast {allowedTypes} filer kan laddas upp.",
	"receipt-notification-trx-details-date": "Datum",
	"credit-card-authorization": "Korttillstånd",
	"address-line1": "Adressrad 1",
	"required-if-not-exists": "{property} krävs när {compareSource} inte har angetts.",
	"required-if-not-equal": "{property} krävs när inte är {compareSource} {compareValue}.",
	"marketing-button-2": "Bygg Din Egen Gratis",
	"receipt-notification-billing-info-header": "Fakturainfo",
	"required-if-after": "{property} krävs när {compareSource} är efter {compareValue}.",
	"element-label-name": "Namn",
	"required-if-equal": "{property} krävs när {compareSource} är {compareValue}.",
	"connected-to-paypal": "Ansluten till PayPal.",
	"people-form-email-quantity-exceeded-message": "E-postadressen måste vara unik.",
	"receipt-notification-order-details-subtotal": "Delsumma",
	"shared-entry-edit-link": "Redigera delade posten.",
	"receipt-notification-trx-details-header": "Transaktionsdetaljer",
	"address-city": "Ort",
	"receipt-notification-order-details-amount-paid": "Belopp Betalas",
	"credit-card-invalid": "Kortet är ogiltigt.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Ett formulär har inkommit.",
	"this-and-that": "{0} och {1}",
	"field-ratingscale-good-poor-label": "Bra/Dålig",
	"network-unavailable-message": "Nätverket är inte tillgängligt. Försök igen senare.",
	"dialog-close": "Stänga",
	"string-format-alphanumeric": "{property} får bara innehålla bokstäver och siffror.",
	"credit-card": "Kreditkort",
	"remove-item": "Avlägsna {item}",
	"receipt-notification-order-details-price-header": "Pris",
	"fileupload-upload-inprogress-message": "Filuppladdning pågår.",
	"public-terms-of-service-link-text": "Villkor för tjänsten",
	"save-and-resume-email-subject": "Spara \u0026 Återuppta Länk",
	"field-repeatingsection-remove-link-text": "Avlägsna",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Lägg till {item}",
	"field-toggle-options": "Ja/Nej|Sant/Falskt|Öppen/Stängd|Aktiva/InIaktiva|Läst/Oläst",
	"order-submit-timeout": "Orderhantering tar alltför lång tid. Försök din beställning senare.",
	"listlength-at-most": "Ange högst {max} {property}.",
	"shared-entry-email-view-message": "Använd länken nedan för att se den delade posten.",
	"order-number-label": "Nummer",
	"card-declined": "Kortet avvisades",
	"fileupload-default-upload-button-text": "Ladda upp",
	"name-prefix": "Titel",
	"address-line2": "Adressrad 2",
	"element-label-email": "E-post",
	"field-ratingscale-good-poor-options": "Mycket dålig|Dålig|Genomsnitt|Bra|Mycket bra",
	"next-button-text": "Nästa",
	"question": "Fråga",
	"address-postalcode": "Postnummer / Zip Code",
	"format-with-description": "{property} måste formateras som {description}.",
	"field-datepicker-prev-month": "Föregående månad",
	"name": "Namn",
	"receipt-notification-order-details-total-footer": "Totalt",
	"confirmation-message": "Tack för att fylla i formuläret. Ditt svar har registrerats.",
	"shared-entry-email-edit-message": "Använd länken nedan för att redigera den delade posten.",
	"field-default-label": "Untitled",
	"required-value": "{property} måste vara {value}.",
	"name-middle": "Mellannamn",
	"fileupload-failed-upload-message": "{fileName} misslyckades att ladda upp.",
	"shared-entry-email-button-label": "Visa posten",
	"field-datepicker-year": "",
	"element-label-phone": "Telefon",
	"TRUE": "SANY",
	"listlength-between": "Ange mellan {min} och {max} {property}.",
	"marketing-button-1": "Prova Det Nu",
	"entry-submission-error-heading": "Fel bearbetning posten",
	"order-not-found-message": "Ingen orderinformation hittas.",
	"format-without-description": "{property} är inte korrekt formaterad.",
	"name-last": "Efternamn",
	"field-ratingscale-one-five-label": "Skala 1 till 5",
	"listlength-at-least": "Ange minst {min} {property}.",
	"united-states": "USA",
	"field-signature-captured": "Fångade",
	"compare-on-or-before": "{property} måste vara på eller före {compareSource}.",
	"order-balance-due-label": "Balansera vederbörlig",
	"required-if-less-than": "{property} krävs när {compareSource} är mindre än {compareValue}.",
	"credit-card-postalcode": "Postnummer",
	"form-not-available-message": "Denna form är för närvarande inte tillgänglig.",
	"element-label-address": "Adress",
	"receipt-notification-trx-details-number": "Nummer",
	"public-submission-warning": "Skicka inte in lösenord genom Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Kopiera eller e-posta länken nedan och återgå till formuläret för att slutföra din ansökan.",
	"fileupload-excluded-file-type-message": "Filer av denna typ kan inte laddas upp.",
	"payment-subtotal": "Delsumma",
	"collapse": "Dölja",
	"save-button-text": "Spara",
	"field-datepicker-prev-year": "Föregående år",
	"signature-type": "skriva",
	"order-amount-minimum": "Att betala måste vara minst 1,00 kr.",
	"string-format-numeric": "{property} får endast innehålla siffror.",
	"entry-confirmation-entry-details-header": "Detaljer",
	"connected-to-venmo": "Ansluten till Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Kvittot",
	"clear": "Klart",
	"today": "Idag",
	"required-name-last": "Efternamn krävs.",
	"marketing-button-3": "Prova Det Nu",
	"expand": "Visa",
	"compare-greater-than": "{property} måste vara större än {compareSource}.",
	"field-ratingscale-will-wont-label": "Kommer/Kommer Inte",
	"required-name-first": "Förnamn krävs.",
	"save-and-resume-one-day-expiration-message": "Kopiera eller e-posta länken nedan och återgå till formuläret inom den nästa dag för att slutföra din ansökan.",
	"required-asterisk": "krävs",
	"credit-card-required": "Kreditkort krävs.",
	"address-state-province-region": "Stat / provins / Region",
	"save-and-resume-email-sent-message": "E-postmeddelandet har skickats.",
	"workflow-action": "Handling",
	"field-ratingscale-will-wont-options": "Definitivt Kommer inte|Förmodligen Inte|Inte säker|Förmodligen kommer|Definitivt kommer",
	"save-and-resume-email-label": "Mejla mig min länk:",
	"field-ratingscale-agree-disagree-options": "Starkt emot|Håller inte|Neutralt|Enas|Instämmer",
	"order-exception-order-already-paid": "Denna ordning har redan betalats.",
	"fileupload-download-text": "Hämta",
	"address-state": "Län",
	"allowed-values": "{property} är inte i listan med tillåtna värden.",
	"shared-entry-workflow-email-button-label": "Öppna formuläret",
	"compare-equal": "{property} måste vara samma som {compareSource}.",
	"field-datepicker-clear": "Töm",
	"name-first": "Förnamn",
	"save-and-resume-message": "Dina framsteg har sparats.",
	"save-and-resume-no-expiration-message": "Kopiera eller e-posta länken nedan och återgå till formuläret för att slutföra din ansökan.",
	"entry-notification-view-details-text": "Visa Detaljer",
	"order-exception-default-message": "Det gick inte att bearbeta transaktioner.",
	"public-report-abuse-link-text": "Rapportera missbruk",
	"order-amount-paid": "Belopp Betalas",
	"element-label-default": "Untitled",
	"countries": "Afghanistan|Albanien|Algeriet|Amerikanska Samoa|Andorra|Angola|Anguilla|Antarktis|Antigua och Barbuda|Argentina|Armenien|Aruba|Australien|Azerbajdzjan|Bahamas|Bahrain|Bangladesh|Barbados|Belgien|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnien-Hercegovina|Botswana|Brasilien|Brunei Darussalam|Bulgarien|Burkina Faso|Burundi|Caymanöarna|Centralafrikanska republiken|Chile|Colombia|Cooköarna|Costa Rica|Cypern|Danmark|Demokratiska republiken Kongo (Kinshasa)|Djibouti|Dominica|Dominikanska republiken|Ecuador|Egypten|Ekvatorialguinea|El Salvador|Elfenbenskusten|Eritrea|Estland|Etiopien|Falklandsöarna|Fiji|Filippinerna|Finland|Frankrike|Franska Guyana|Franska Polynesien|Franska sydterritorierna|Färöarna|Förenade Arabemiraten|Gabon|Gambia|Georgien|Ghana|Gibraltar|Grekland|Grenada|Grönland|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Heliga stolen|Honduras|Hong Kong|Indien|Indonesien|Irak|Iran (islamiska republiken)|Irland|Island|Isle of Man|Israel|Italien|Jamaica|Japan|Jemen|Jordanien|Julön|Kambodja|Kamerun|Kanada|Kap Verde|Kazakstan|Kenya|Kina|Kirgizistan|Kiribati|Kokosöarna (Keelingöarna)|Komorerna|Kongo, Republiken of(Brazzaville)|Korea, demokratiska \u0027 s rep (Nordkorea)|Korea, Republiken (Sydkorea)|Kosovo|Kroatien|Kuba|Kuwait|Lao, människor \u0027 s demokratiska republiken|Lesotho|Lettland|Libanon|Liberia|Libyen|Liechtenstein|Litauen|Luxemburg|Macau|Madagaskar|Republiken Nordmakedonien|Malawi|Malaysia|Maldiverna|Mali|Malta|Marocko|Marshallöarna|Martinique|Mauretanien|Mauritius|Mayotte|Mexico|Mikronesien, federalt påstår av|Moçambique|Moldavien, Republiken|Monaco|Mongoliet|Montenegro|Montserrat|Myanmar, Burma|Namibia|Nauru|Nederländerna|Nederländska Antillerna|Nepal|Nicaragua|Niger|Nigeria|Niue|Nordmarianerna|Norge|Nya Zeeland|Nya Kaledonien|Oman|Pakistan|Palau|Palestinska områdena|Panama|Papua Nya Guinea|Paraguay|Peru|Pitcairnöarna|Polen|Portugal|Puerto Rico|Qatar|Réunion|Rumänien|Rwanda|Ryska federationen|Saint Kitts och Nevis|Saint Lucia|Saint Vincent och Grenadinerna|Salomonöarna|Samoa|San Marino|Sao Tome och Principe|Saudiarabien|Schweiz|Senegal|Serbien|Seychellerna|Sierra Leone|Singapore|Slovakien (Slovakiska republiken)|Slovenien|Somalia|Spanien|Sri Lanka|Storbritannien|Sudan|Surinam|Swaziland|Sverige|Sydafrika|Syrien, Syrien|Södra Sudan|Tadzjikistan|Taiwan (Republiken Kina)|Tanzania; officiellt Förenade republiken Tanzania|Tchad|Thailand|Tibet|Tjeckien|Togo|Tokelauöarna|Tonga|Trinidad och Tobago|Tunisien|Turkiet|Turkmenistan|Turks och Caicosöarna|Tuvalu|Tyskland|Uganda|Ukraina|Ungern|Uruguay|USA|Uzbekistan|Wallis-och Futunaöarna|Vanuatu|Vatikanstaten (Heliga stolen)|Venezuela|Vietnam|Virgin Islands (brittisk)|Virgin Islands (US)|Vitryssland|Västsahara|Zambia|Zimbabwe|Österrike|Östtimor (Östtimor)",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Ordern måste innehålla minst en radartikel.",
	"compare-not-equal": "{property} måste vara olika från {compareSource}.",
	"entry-notification-footer": "Du får detta mail eftersom du har valt alternativet ta emot e-postmeddelanden på din form i Cognito Forms.",
	"save-and-resume-copy-link-label": "Kopiera formuläret länk:",
	"entry-confirmation-footer": "Du får detta mail eftersom du slutfört en transaktion med [Name].",
	"required-if-on-or-before": "{property} krävs när {compareSource} är på eller före {compareValue}.",
	"string-format": "{property} måste formateras som {formatDescription}.",
	"switch-to-drawing-mode": "Byt till ritläge från skrivläge.",
	"switch-to-typing-mode": "Byt till skrivläge från ritläge."
};
